/* Header behaviour that predates the custom elements. Loaded deferred, after jQuery. */
document.addEventListener('DOMContentLoaded', function() {
    $(".menu-drawer-container .icon-close").click(function() {
      $(".menu-drawer-container").removeClass('menu-opening');
      
    });

    $(".menu-drawer-container .menu_overlay").click(function() {
      $(".menu-drawer-container").removeClass('menu-opening');
    });
        
    $("#cart-icon-bubble").click(function(event) {
      // The icon is a real link to the cart page (keyboard, no-JS and open-in-new-tab);
      // a plain click opens the drawer instead of navigating.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.which > 1) return;
      event.preventDefault();
      $(".cart-content").addClass('active');
      $(".hearder-cart .overlay").addClass('overlay_active');
    });
        
    $(".user-background").click(function() {
      $(".tm_header-dropdown .my-account").slideToggle();
      $('.tm_header-dropdown').toggleClass('active')
    });
        
    $('.close-icon, .overlay').click(function() {
      $(".cart-content").removeClass('active');
       $(".overlay").removeClass('overlay_active');
    })

    $("#cart-icon-bubble").click(function() { 
      $("#cart_reload").load("#cart_reload .cart_content > *");
    });
});
     
function responsivecolumn(){
    if ($(document).width() <= 989)
    { 
        $('.announcement-bar__link.link.link--text').appendTo('#menu-drawer .menu-drawer__navigation');
    }
    else 
    {
       $('.announcement-bar__link.link.link--text').appendTo('.announcement-bar .announcement-bar__link.link.link--text');
    }
   if ($(document).width() <= 575)
    { 
        $('.announcement-bar .left-part .announcement-bar-text').appendTo('#menu-drawer .menu-drawer__navigation');
    }
    else 
    {
       $('.announcement-bar-text').appendTo('.announcement-bar .left-part');
    }
}

document.addEventListener('DOMContentLoaded', function() {responsivecolumn();});

/* Registered once; responsivecolumn() runs again on every resize. */
document.addEventListener('DOMContentLoaded', function() {
    /* The sticky bar takes over once the header's own height has scrolled out; the 20px
       gap on the way back keeps the class from flickering at the boundary. */
    var headerEl = document.querySelector('.header-wrapper');
    var stickyOn = false;
    /* Measured only at scroll position 0: the fixed header is shorter, so a live
       measurement would move the threshold while the class is on. */
    var headerH = 0;
    function measureHeader() {
        if (headerEl && !stickyOn && window.pageYOffset === 0) {
            headerH = headerEl.offsetHeight;
        }
    }
    function headerScroll() {
        var y = window.pageYOffset;
        if (!headerH) { headerH = headerEl.offsetHeight; }
        if (!stickyOn && y > headerH) {
            stickyOn = true;
            headerEl.classList.add('fixed');
        } else if (stickyOn && y <= headerH - 20) {
            stickyOn = false;
            headerEl.classList.remove('fixed');
        }
    }
    if (headerEl) {
        window.addEventListener('scroll', headerScroll, { passive: true });
        window.addEventListener('resize', measureHeader);
        window.addEventListener('load', measureHeader);
        measureHeader();
        headerScroll();
    }
});
$(window).resize(function(){responsivecolumn();});

/* Language and currency selectors in the announcement bar and top bar. */
var HEADER_ANIM = 200;
document.addEventListener('DOMContentLoaded', function() {
    $(".FooterLanguage").click(function() {
        $("#FooterLanguageList").slideToggle(HEADER_ANIM);
        $('.LanguageList').toggleClass('active');
      	$("#FooterCountryList").slideUp(HEADER_ANIM);
        $('.CurrencyList').removeClass('active');
    })
});
      document.addEventListener('DOMContentLoaded', function() {
    $(".FooterCurrency").click(function() {
        $("#FooterCountryList").slideToggle(HEADER_ANIM);
        $('.CurrencyList').toggleClass('active');
      	$("#FooterLanguageList").slideUp(HEADER_ANIM);
        $('.LanguageList').removeClass('active');
    })
});
